import styled from 'styled-components';
import { DropdownMixin } from '../../mixins/components/DropdownMixin';
import { Dialog } from '../Dialog/Dialog';
export var StyledDropdown = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "StyledDropdown",
  componentId: "c11n-8-107-0__sc-1snjbke-0"
})(["", ""], DropdownMixin);